module.exports = "../static/media/icon_male.afbfb1b5.png";